import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { Exercise, ExerciseDetail, ExerciseSearchResult } from './_types';

export const normalizeExerciseSearchResult = (
  result: ExerciseSearchResult
): Exercise => {
  return {
    id: result.id,
    name: result.term,
    description: result.data.json.description,
    muscleGroup: result.data.json.muscleGroup,
    difficulty: result.data.json.difficulty,
    equipmentRequired: result.data.json.equipmentRequired,
    videoUrl: result.data.json.videoUrl,
    thumbnailUrl: result.data.json.thumbnailUrl,
  };
};

export const normalizeExercise = (exercise): ExerciseDetail => {
  exercise.steps =
    exercise.steps?.map((step, i) => ({ id: i, name: step })) || [];
  exercise.tips = exercise.tips?.map((tip, i) => ({ id: i, name: tip })) || [];
  exercise.variations =
    exercise.variations?.map((variation, i) => ({
      id: i,
      name: variation,
    })) || [];

  const normalizedExercise = camelcaseKeys(exercise, {
    deep: true,
  }) as ExerciseDetail;

  return normalizedExercise;
};

export const denormalizeExercise = (exercise: Partial<ExerciseDetail>) => {
  const decamelize_keys = decamelizeKeys(exercise, {
    deep: true,
  }) as Partial<ExerciseDetail> & {
    tag_list?: string;
    secondary_muscle_group_ids?: number[];
    equipment_ids?: number[];
    exercise_type_ids?: number[];
    approved?: boolean | null;
    secondary_muscle_groups?: any[];
    public?: boolean;
    equipment?: any[];
    type_ids?: any[];
  };

  if (decamelize_keys.tags) {
    decamelize_keys.tag_list = decamelize_keys.tags.join(',');
  }
  decamelize_keys.secondary_muscle_group_ids =
    decamelize_keys.secondary_muscle_groups?.map((group: any) => group.id);
  decamelize_keys.approved = decamelize_keys.public;
  decamelize_keys.equipment_ids = decamelize_keys.equipment || [];
  decamelize_keys.exercise_type_ids = decamelize_keys.type_ids || [];
  decamelize_keys.steps = decamelize_keys.steps?.map((step: any) => step.name);
  decamelize_keys.tips = decamelize_keys.tips?.map((tip: any) => tip.name);
  decamelize_keys.variations = decamelize_keys.variations?.map(
    (variation: any) => variation.name
  );

  const fieldsToRemove = [
    'public',
    'tags',
    'secondary_muscle_groups',
    'equipment',
    'type_ids',
    'types',
    'id',
    'difficulty_level',
    'mechanics_type_id',
    'thumbnail',
    'video_embed_url',
  ];

  removeReadOnlyFields(decamelize_keys, fieldsToRemove);

  return decamelize_keys;
};
